import DataOrganismsContainer from "./DataOrganismsContainer";

export default DataOrganismsContainer;